import { formDataFetch } from './fetchHelpers'
import { setOpenModalButton } from './modals'
import bindOnce from './bindOnce'
import renderWishlistButton from './listing_tile_rendering/wishlistButtonRenderer'
import { trackAddToWishlist } from '../analytics/events/wishlist'
import { postFetchWrapper } from '../utils/fetchHelpers'
import buildUrl from '../utils/apiHelpers'

export default async function setUpAddToWishlistBehaviour () {
  const isLoggedIn = JSON.parse(document.querySelector('body').getAttribute('data-logged-in'))
  if (isLoggedIn) {
    await setAddToWishlistModal()

    const addToWishlistActive = document.getElementById('vjs-add-to-wishlist-active')

    if (addToWishlistActive) showAddToWishlistModal(addToWishlistActive)
  } else {
    setUpGuestAddToDefaultWishlist()
    setUpWishlistLogin()
  }
}

export function setUpGuestAddToDefaultWishlist () {
  const guestWishlistAllowedEl = document.querySelector('#vjs-guest-wishlist-allowed')
  const guestWishlistAllowed = JSON.parse(guestWishlistAllowedEl?.value)
  if (!guestWishlistAllowed) return

  document.querySelectorAll('.vjs-guest-add-to-wishlist').forEach(bindGuestAddToDefaultWishlist)

  attachRemoveFromWishlistClickListeners()
}

// Tiles rendered after page load (the VERA chat): binds the buttons under root only.
export function bindWishlistButtons (root) {
  const isLoggedIn = JSON.parse(document.querySelector('body').getAttribute('data-logged-in'))

  root.querySelectorAll('.vjs-modal-button').forEach(setOpenModalButton)
  root.querySelectorAll('.vjs-listing-wishlisted').forEach(bindRemoveFromWishlist)
  if (isLoggedIn) {
    root.querySelectorAll('.vjs-wishlist-modal').forEach(initAddToWishlistModalOnButtonClick)
  } else {
    if (JSON.parse(document.querySelector('#vjs-guest-wishlist-allowed')?.value || 'false')) {
      root.querySelectorAll('.vjs-guest-add-to-wishlist').forEach(bindGuestAddToDefaultWishlist)
    }
    root.querySelectorAll('.vjs-listing-tile-add-to-wishlist-button').forEach(bindWishlistLogin)
  }
}

function bindGuestAddToDefaultWishlist (button) {
  bindOnce(button, 'click', 'GuestWishlist', event => {
    const { listingId } = button.dataset
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    event.preventDefault()

    const builtUrl = buildUrl('/api/v1/add_to_default_guest_wishlist')
    postFetchWrapper(builtUrl, { wishlist_item: { listing_id: listingId }, authenticity_token: csrfToken })
      .then(response => response.json())
      .then(data => {
        const buttons = Array.from(document.querySelectorAll(`button.vjs-guest-add-to-wishlist[data-listing-id="${listingId}"]`))

        buttons.forEach(el => setWishlistedButton(el, data.newWishListItem.id))
        trackAddToWishlist(listingId)
        addToWishlistUpdateDomStore(Number(listingId), data.newWishListItem.id)

        notifyUserOfWishlistTemporariness()
      })
  })
}

export function showAddToWishlistModal (addToWishlistActive) {
  const listingId = addToWishlistActive.dataset.listingId
  const modalContainer = document.getElementById('add-to-wishlist')
  const listingIdInputs = modalContainer.querySelectorAll('input[name="wishlist_item[listing_id]"]')
  const createNewWishlistButton = modalContainer.querySelector('.vjs-create-new-wishlist')

  listingIdInputs.forEach(input => {
    input.value = listingId
  })

  modalContainer.querySelectorAll('.vjs-add-to-wishlist-form').forEach(initAddToWishlistModalForms)

  createNewWishlistButton.dataset.listingId = listingId

  modalContainer.classList.add('show')
  addToWishlistActive.remove()
}

function notifyUserOfWishlistTemporariness () {
  const guestWishlistInfo = document.getElementById('vjs-guest-wishlist-is-temporary-info')

  if (guestWishlistInfo) {
    guestWishlistInfo.classList.remove('hidden')
    setTimeout(() => triggerTransitionToOpacityZero(guestWishlistInfo), 5000)
    setTimeout(() => resetTransitionState(guestWishlistInfo), 5500)
  }
}

function triggerTransitionToOpacityZero (element) {
  element.classList.add('opacity-0')
}

function resetTransitionState (element) {
  element.classList.remove('opacity-0')
  element.classList.add('hidden')
}

export async function setAddToWishlistModal () {
  const addToWishlistButtons = document.querySelectorAll('.vjs-wishlist-modal')
  const wishlistItemsIds = document.querySelector('.vjs-wishlist-item-ids')

  if (wishlistItemsIds && wishlistItemsIds.value) await getUserWishlistsRequest()

  addToWishlistButtons.forEach(button => initAddToWishlistModalOnButtonClick(button))

  attachRemoveFromWishlistClickListeners()

  setupWishlistLoginButtons()
  createNewWishlistModal()
}

function attachRemoveFromWishlistClickListeners () {
  const removeFromWishlistButtons = document.querySelectorAll('.vjs-listing-wishlisted')
  removeFromWishlistButtons.forEach(bindRemoveFromWishlist)
}

function bindRemoveFromWishlist (button) {
  bindOnce(button, 'click', 'RemoveFromWishlist', clickEvent => removeFromWishlistRequest(clickEvent.currentTarget))
}

function setupWishlistLoginButtons () {
  const loginWishlistButtons = document.querySelectorAll('.vjs-wishlist-login')
  loginWishlistButtons.forEach(button =>
    bindOnce(button, 'click', 'WishlistLogin', () => {
      const listingIdInput = document.getElementById('vjs-login-modal__listing-id')
      if (listingIdInput) {
        listingIdInput.setAttribute('value', button.dataset.listingId)
      } else {
        const input = document.createElement('input')
        input.setAttribute('type', 'hidden')
        input.setAttribute('id', 'vjs-login-modal__listing-id')
        input.setAttribute('name', 'wishlist_item[listing_id]')
        input.setAttribute('value', button.dataset.listingId)
        document.getElementById('new_user')?.appendChild(input)
      }

      const oauthAndRegisterButtons = document.querySelectorAll('.vjs-oauth-button, .vjs-register-here-link')
      oauthAndRegisterButtons.forEach(registerButton => {
        const baseUrl = registerButton.href.split('?')[0]
        registerButton.href = baseUrl + `?wishlist_item[listing_id]=${button.dataset.listingId}`
      })
    })
  )
}

export function createNewWishlistModal () {
  const createNewWishlistButton = document.querySelector('.vjs-create-new-wishlist')
  if (!createNewWishlistButton) return

  bindOnce(createNewWishlistButton, 'click', 'CreateNewWishlist', () => {
    const modalContainer = document.getElementById(createNewWishlistButton.dataset.modal)
    const listingIdInput = modalContainer.querySelector('input[name="listing_id"]')

    listingIdInput.value = createNewWishlistButton.dataset.listingId

    const createNewWishlistForm = modalContainer.querySelector('.vjs-create-new-wishlist-form')

    createNewWishlistForm.addEventListener('submit', submitEvent => {
      const shouldReload = JSON.parse(submitEvent.target.dataset.shouldReload)
      if (!shouldReload) submitEvent.preventDefault()

      submitEvent.stopImmediatePropagation()
      createNewWishlistRequest(createNewWishlistButton.dataset.listingId, submitEvent.target)

      if (document.querySelector('.vjs-modal.show')) {
        document.querySelector('.vjs-modal.show').classList.remove('show')
      }

      createNewWishlistForm.reset()
    })
  })
}

function createNewWishlistRequest (listingId, target) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]').content

  window.fetch('/api/v1/wishlists', {
    method: 'POST',
    mode: 'cors',
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': csrfToken },
    body: new FormData(target)
  })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      const buttons = document.querySelectorAll(`button.vjs-wishlist-modal[data-listing-id="${listingId}"]`)
      Array.from(buttons).forEach(el => {
        setWishlistedButton(el, data.newWishListItemId)
      })
      getUserWishlistsRequest() // update Wishlist modal
      trackAddToWishlist(listingId)
      addToWishlistUpdateDomStore(Number(listingId), data.newWishListItemId)
    })
}

export function getUserWishlistsRequest () {
  return window.fetch('/api/v1/wishlists', { method: 'GET' })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      const wishlists = data.wishLists
      // The list can arrive after a heart opened the modal: keep that heart's listing.
      const listingId = document.querySelector('.vjs-create-new-wishlist')?.dataset.listingId || ''

      // Cleanup Wishlist squares from list on modal
      while (Array.from(document.querySelectorAll('.vjs-user-wishlists li')).length > 0) {
        document.querySelector('.vjs-user-wishlists').removeChild(
          document.querySelector('.vjs-user-wishlists').lastChild
        )
      }

      wishlists.forEach(wishlist => {
        document.querySelector('.vjs-user-wishlists').insertAdjacentHTML('beforeend',
          `<li>
            <form class="vjs-add-to-wishlist-form" action="/api/v1/wishlist_items" method="POST">
              <input type="hidden" name="wishlist_item[listing_id]" value="${listingId}">
              <input type="hidden" name="wishlist_item[wishlist_id]" value="${wishlist.id}">
              <button type="submit" class="vsd-wishlist-button">
                <img class="border border-midnight-black-20"
                  src="${
                    wishlist.cover_image_url
                    ? wishlist.cover_image_url
                    : 'https://static-assets.vinterior.co/wishListTileDefault.png'
                }" />
                <p class="font-sans font-bold text-size-sm text-midnight-black-80">${wishlist.title}</p>
              </button>
            </form>
          </li>`
        )
      })
      document.querySelectorAll('.vjs-user-wishlists .vjs-add-to-wishlist-form').forEach(initAddToWishlistModalForms)
    })
}

function initAddToWishlistModalOnButtonClick (button) {
  bindOnce(button, 'click', 'AddToWishlistModal', () => {
    const modalContainer = document.getElementById(button.dataset.modal)
    const listingIdInputs = modalContainer.querySelectorAll('input[name="wishlist_item[listing_id]"]')
    const createNewWishlistButton = modalContainer.querySelector('.vjs-create-new-wishlist')

    listingIdInputs.forEach(input => {
      input.value = button.dataset.listingId
    })

    modalContainer.querySelectorAll('.vjs-add-to-wishlist-form').forEach(initAddToWishlistModalForms)

    createNewWishlistButton.dataset.listingId = button.dataset.listingId
  })
}

// The form carries the listing of the heart that opened the modal last, so it is bound once.
function initAddToWishlistModalForms (form) {
  bindOnce(form, 'submit', 'AddToWishlist', submitEvent => {
    submitEvent.preventDefault()
    submitEvent.stopImmediatePropagation()

    addToWishlistRequest(submitEvent.currentTarget)

    if (document.querySelector('.vjs-modal.show')) {
      document.querySelector('.vjs-modal.show').classList.remove('show')
    }
  })
}

function addToWishlistRequest (target) {
  const formData = new FormData(target)

  formDataFetch(target)
    .then(response => {
      if (!response.ok) {
        return response.json().then(data => {
          throw new Error(data.error || 'Failed to add to wishlist')
        })
      }
      return response.json()
    })
    .then((data) => {
      const listingIdToAdd = formData.get('wishlist_item[listing_id]')
      const wishlistItemIdToAdd = data.newWishListItem.id

      document.querySelectorAll(`button.vjs-wishlist-modal[data-listing-id="${listingIdToAdd}"]`)
        .forEach(button => setWishlistedButton(button, wishlistItemIdToAdd))
      getUserWishlistsRequest()
      trackAddToWishlist(listingIdToAdd)
      addToWishlistUpdateDomStore(Number(listingIdToAdd), wishlistItemIdToAdd)
    })
    .catch(error => {
      console.log('Failed to add to wishlist:', error.message)
    })
}

function addToWishlistUpdateDomStore (listingIdToAdd, wishlistItemIdToAdd) {
  if (!document.querySelector('.vjs-wishlist-item-ids')) return

  const wishlistDomStore = document.querySelector('.vjs-wishlist-item-ids').value
  const wishlistIdPairsFromDom = wishlistDomStore.length > 0 ? JSON.parse(wishlistDomStore) : []
  const wishlistIdPairsWithCurrentAdded = [...wishlistIdPairsFromDom, [wishlistItemIdToAdd, listingIdToAdd]]

  document.querySelector('.vjs-wishlist-item-ids').value = JSON.stringify(wishlistIdPairsWithCurrentAdded)
}

// A save the server rejected (e.g. already in that wishlist) comes back without an id.
function setWishlistedButton (button, wishlistedItemId) {
  if (!button || !wishlistedItemId) return
  const wishlistedButtonHtml = renderWishlistButton(button.dataset.listingId, wishlistedItemId, true, button.dataset.buttonType)
  const wishlistedButton = htmlToElement(wishlistedButtonHtml)

  button.parentNode?.insertBefore(wishlistedButton, button)
  button.remove()

  bindRemoveFromWishlist(wishlistedButton)
}

function removeFromWishlistRequest (target) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]').content

  window.fetch(`/api/v1/wishlist_items/${target.dataset.wishlistedItemId}`, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-Token': csrfToken,
      'Content-type': 'application/json; charset=UTF-8'
    }
  })
    .then(response => response.json())
    .then(() => {
      const listingIdToRemove = Number(target.dataset.listingId)
      const wishlistItemIdToRemove = Number(target.dataset.wishlistedItemId)
      const onWishlistView = target.dataset.onWishlistView === 'true'

      if (onWishlistView) {
        hideTheWishlistItemTile(listingIdToRemove)
      } else {
        document.querySelectorAll(`button.vjs-listing-wishlisted[data-wishlisted-item-id="${wishlistItemIdToRemove}"]`)
          .forEach(setAddToWishlistButton)
      }
      removeFromWishlistUpdateDomStore(listingIdToRemove, wishlistItemIdToRemove)
    })
}

function hideTheWishlistItemTile (listingIdToRemove) {
  const wishlistItemTile = document.querySelector(`[data-productid="${listingIdToRemove}"]`)
  const container = wishlistItemTile?.closest('.vjs-wishlist-listing-container')
  const elementToHide = (container || wishlistItemTile)
  elementToHide?.classList.add('hidden')
}

function removeFromWishlistUpdateDomStore (listingIdToRemove, wishlistItemIdToRemove) {
  if (!document.querySelector('.vjs-wishlist-item-ids')) return

  const wishlistDomStore = document.querySelector('.vjs-wishlist-item-ids').value
  const wishlistIdPairsFromDom = wishlistDomStore.length > 0 ? JSON.parse(wishlistDomStore) : []
  const wishlistIdPairsWithCurrentRemoved = wishlistIdPairsFromDom.filter((idPair) => {
    const [wishlistItemId, listingId] = idPair
    return !(wishlistItemId === wishlistItemIdToRemove && listingId === listingIdToRemove)
  })

  document.querySelector('.vjs-wishlist-item-ids').value = JSON.stringify(wishlistIdPairsWithCurrentRemoved)
}

function setAddToWishlistButton (wishlistedButton) {
  const { listingId, buttonType } = wishlistedButton.dataset
  const isLoggedIn = JSON.parse(document.querySelector('body').getAttribute('data-logged-in'))

  const addToWishlistButtonHtml = renderWishlistButton(listingId, null, isLoggedIn, buttonType)
  const addToWishlistButton = htmlToElement(addToWishlistButtonHtml)

  wishlistedButton.parentNode?.insertBefore(addToWishlistButton, wishlistedButton)
  wishlistedButton.remove()

  if (isLoggedIn) {
    // having both lines below is a workaround to allow the modal to open a second time
    // TODO: refactor to avoid this workaround and make more readable.
    setOpenModalButton(addToWishlistButton)
    initAddToWishlistModalOnButtonClick(addToWishlistButton)
  } else {
    setUpGuestAddToDefaultWishlist()
  }
}

function setUpWishlistLogin () {
  const wishlistLoginBtns = document.querySelectorAll('.vjs-listing-tile-add-to-wishlist-button')
  const loginModalPurpose = document.getElementById('vjs-login-modal-purpose')
  const loginModalWishlistListingId = document.getElementById('vjs-login-modal-wishlist-listing-id')

  if (!wishlistLoginBtns || !loginModalPurpose || !loginModalWishlistListingId) return

  wishlistLoginBtns.forEach(bindWishlistLogin)
}

// The modal's fields are looked up on click: the VERA chat may add the modal after the button.
function bindWishlistLogin (btn) {
  bindOnce(btn, 'click', 'WishlistLoginPurpose', () => {
    const loginModalPurpose = document.getElementById('vjs-login-modal-purpose')
    const loginModalWishlistListingId = document.getElementById('vjs-login-modal-wishlist-listing-id')
    if (!loginModalPurpose || !loginModalWishlistListingId) return

    loginModalPurpose.value = 'add-to-wishlist'
    loginModalWishlistListingId.value = btn.dataset.listingId

    const oauthAndRegisterButtons = document.querySelectorAll('.vjs-oauth-button, .vjs-register-here-link')
    oauthAndRegisterButtons.forEach(registerButton => {
      const baseUrl = registerButton.href.split('?')[0]
      registerButton.href = baseUrl + `?login_purpose=add-to-wishlist&login_wishlist_listing_id=${btn.dataset.listingId}`
    })
  })
}

// Helper so we can reuse wishlistButtonRenderer
function htmlToElement (html) {
  const div = document.createElement('div')
  div.innerHTML = html.trim()
  return div.firstChild
}
